import * as angular from "angular";
import {IController} from "angular";
import {AuthenticationAlertsService} from "../../services/authentication-alerts.service";
import {SignupRequestsService} from "../../services/signup-requests.service";

export class signUpViewCtrl implements IController {

  public subscriptionRef: any;
  private organization: any;
  private loading: any;

  /* @ngInject */
  constructor(private $log, private $state, private signupRequestsService: SignupRequestsService,
              private authenticationAlertsService: AuthenticationAlertsService, private subscription) {
  }

  $onInit() {
    this.subscriptionRef = this.subscription;
    this.organization = {
      name: this.subscription.subscriptionName
    }
    this.loading = false;
  };

  subscribe() {
    this.loading = true;
    this.signupRequestsService.createOrganization(
      this.organization,
      this.subscription.subscriptionId,
      this.subscription.planId,
      this.subscription.quantity
    )
      .then(() => {
        this.authenticationAlertsService.signupSuccess();
        this.$state.go('authentication.login');
      })
      .catch((error) => {
        this.authenticationAlertsService.signupError();
        this.$log.error('Create Organization failed', error);
      })
      .finally(() => {
        this.loading = false;
      });

  }

}

angular
  .module('bringoz.admin.authentication')
  .component('signUpView', {
    bindings: {
      subscription: '<'
    },
    template: require('./sign-up-view.html').default,
    controller: signUpViewCtrl
  });
